<template>
    <transition
        ref="rootAppLoadRef"
        name="app-loader"
        appear
    >
        <div
            v-if="isGlobalLoading"
            :aria-busy="isGlobalLoading"
            aria-label="Loading"
            class="app-loader"
        >
            <div
                class="app-loader__background"
            />
            <div class="vc-loading__content">
                <Stretch
                    :size="68"
                />
            </div>
        </div>
    </transition>
</template>

<script setup lang="ts">
import Stretch from '@/components/RedesignBaseComponents/Loader/Stretch.vue'
import { isGlobalLoading } from '@/composables/useGlobalLoader'
</script>

<style lang="scss">
.app-loader {
    --background-overlay-color: color-mix(in srgb, var(--mainTextColor-color, #000) 30%, transparent);
    @apply
    fixed
    inset-0
    flex
    items-center
    justify-center
    overflow-hidden
    z-999999;
    &__background {
        @apply
        absolute
        bottom-0
        left-0
        right-0
        top-0
        opacity-50
        pointer-events-none;
        background-color: var(--background-overlay-color);
    }
}
body:has(.app-loader) {
    @apply overflow-y-hidden;
}

.app-loader-enter-active, .app-loader-leave-active {
    transition: opacity .5s;
}
.app-loader-enter, .app-loader-leave-to {
    @apply opacity-0;
}
</style>
